export const DEFAULT_CURRENCY_CODE_ASW = 'JPY';

/**
 * オフィスコード
 * */
/** ANABizオフィスコード */
export const ANA_BIZ_OFFICE_CODE = 'TYONH08BZ';
/** 有償日本オフィスコード */
export const JAPANESE_REVENUE_OFFICE_CODE = 'TYONH08AA';
/** APFオフィスコード */
export const APF_OFFICE_CODE = 'TYONH08AP';
